
__webpack_require__.debugRequireIds = {
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/google-sprite.css": 47407,
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/twitter-sprite.css": 72989,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/google-sprite.css": 1040,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/twitter-sprite.css": 62332,
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 80418,
	"./generated/emoji/google.webp": 94213,
	"./generated/emoji/twitter.webp": 60889,
	"./src/base_page_params.ts": 80371,
	"./src/blueslip.ts": 7717,
	"./src/blueslip_stacktrace.ts": 51761,
	"./src/bot_types.ts": 41548,
	"./src/bundles/common.ts": 16004,
	"./src/bundles/legacy_portico_bundle.ts": 96032,
	"./src/csrf.ts": 60737,
	"./src/i18n.ts": 65291,
	"./src/loading_error.ts": 88794,
	"./src/portico/google-analytics.ts": 74024,
	"./src/portico/legacy_header.ts": 56717,
	"./src/portico/portico_modals.ts": 99289,
	"./src/portico/tippyjs.ts": 2533,
	"./src/realm_user_settings_defaults.ts": 95387,
	"./src/retry_backoff.ts": 74798,
	"./src/sentry.ts": 8308,
	"./src/state_data.ts": 63809,
	"./src/stream_types.ts": 51709,
	"./src/types.ts": 98826,
	"./src/user_settings.ts": 44514,
	"./src/user_status_types.ts": 96075,
	"./src/util.ts": 36783,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"@sentry/conventions/attributes": 59966,
	"@zxcvbn-ts/dictionary-compression/decompress": 81395,
	"altcha": 26971,
	"core-js/modules/es.array-buffer.detached.js": 41358,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 76527,
	"core-js/modules/es.array-buffer.transfer.js": 42639,
	"core-js/modules/es.array.includes.js": 66326,
	"core-js/modules/es.array.push.js": 97211,
	"core-js/modules/es.iterator.constructor.js": 86074,
	"core-js/modules/es.iterator.filter.js": 59238,
	"core-js/modules/es.iterator.find.js": 65919,
	"core-js/modules/es.iterator.map.js": 33520,
	"core-js/modules/es.iterator.some.js": 71372,
	"core-js/modules/es.json.parse.js": 56133,
	"core-js/modules/es.json.stringify.js": 28987,
	"core-js/modules/es.map.get-or-insert-computed.js": 346,
	"core-js/modules/es.map.get-or-insert.js": 88536,
	"core-js/modules/es.set.difference.v2.js": 1501,
	"core-js/modules/es.set.intersection.v2.js": 62235,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 8206,
	"core-js/modules/es.set.is-subset-of.v2.js": 78715,
	"core-js/modules/es.set.is-superset-of.v2.js": 42972,
	"core-js/modules/es.set.symmetric-difference.v2.js": 94643,
	"core-js/modules/es.set.union.v2.js": 14303,
	"core-js/modules/es.typed-array.with.js": 97660,
	"core-js/modules/es.uint8-array.set-from-base64.js": 61687,
	"core-js/modules/es.uint8-array.set-from-hex.js": 91471,
	"core-js/modules/es.uint8-array.to-base64.js": 48605,
	"core-js/modules/es.uint8-array.to-hex.js": 67349,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"jquery-validation": 9905,
	"lodash": 35558,
	"micromodal": 94456,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 26798
};